import React, { useState, useEffect } from 'react';
import api from '../../../_utility/AxiosConfig';

function SocialLogin({ setAuthModalMode, closeModal }) {
    const [urls, setUrls] = useState({
        facebook: null,
        google: null
    });

    useEffect(() => {
        const cachedUrls = sessionStorage.getItem('socialLoginUrls');

        if (cachedUrls) {
            setUrls(JSON.parse(cachedUrls));
        } else {
            Promise.all([
                api.post('/api/auth/facebook'),
                api.post('/api/auth/google')
            ])
            .then(([facebookRes, googleRes]) => {
                const socialUrls = {
                    facebook: facebookRes.data.url,
                    google: googleRes.data.url
                };
                sessionStorage.setItem('socialLoginUrls', JSON.stringify(socialUrls));
                setUrls(socialUrls);
            })
            .catch((error) => {
                console.error('Error fetching social login URLs:', error);
            });
        }
    }, []);

    const handleSocialLogin = (provider) => {
        const loginUrl = urls[provider];
        if (!loginUrl) return;
    
        const width = 500;
        const height = 600;
    
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
        const screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
    
        const left = dualScreenLeft + (screenWidth - width) / 2;
        const top = dualScreenTop + (screenHeight - height) / 2;
    
        window.open(
            loginUrl,
            `${provider} Login`,
            `scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`
        );
    
        closeModal();
    };

    return (
        <ul className="nav nav-pills nav-justified mb-3">
            <li className="nav-item w-50 mr-3" role="presentation">
                <button
                    disabled={true}
                    className="btn btn-primary text-white w-100"
                    onClick={() => handleSocialLogin('facebook')}
                    // disabled={!urls.facebook}
                >
                    <i className="fa fa-facebook"></i> Facebook
                </button>
            </li>
            <li className="nav-item w-50" role="presentation">
                <button
                    className="btn btn-danger text-white w-100"
                    onClick={() => handleSocialLogin('google')}
                    disabled={!urls.google}
                >
                    <i className="fa fa-google"></i> Google
                </button>
            </li>
        </ul>
    );
}

export default SocialLogin;

